import React from 'react';
import { Star } from 'lucide-react';

/**
 * Compact 5-star compétence rating with a numeric label. Used in the
 * driver card header and in the recruit list. Extracted from HR.jsx on
 * 28/05/2026.
 */
export default function CompetenceStars({ value, max = 5 }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: max }, (_, i) => (
        <Star
          key={i}
          className={`w-3 h-3 ${i < Math.round(value) ? 'text-warn fill-amber-400' : 'text-slate-700'}`}
        />
      ))}
      <span className="text-[10px] text-slate-500 ml-1">{value.toFixed(1)}</span>
    </div>
  );
}
